import React from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";

export default function Refund() {
    return (
        <>
            <Navbar isDownloadVisible={false} />
            <section className="policy-section">
                <h1 className="policy-title">Refund Policy</h1>
                <ol>
                    <li>
                        <h2 className="policy-section-title">
                            7-Day Money-Back Guarantee
                        </h2>
                        <p>
                            Oakmate offers a 7-day money-back guarantee from the
                            date of your initial subscription payment. You can
                            request a full refund anytime within 7 days of
                            subscribing to Oakmate Pro - for any reason or no
                            reason at all. Our refund policy is unconditional:
                            there are no hoops to jump through or questions we
                            will ask.
                        </p>
                        <p>
                            <strong>Note:</strong> This guarantee applies only
                            to your first subscription payment. Subsequent
                            subscription renewals are non-refundable.
                        </p>
                    </li>
                    <li>
                        <h2 className="policy-section-title">
                            How to Request a Refund
                        </h2>
                        <p>
                            To request a refund, contact us within 7 days of
                            your initial subscription payment. You can:
                        </p>
                        <ul>
                            <li>Email us at contact@oakmate.app</li>
                            <li>
                                Use the refund request form in your account
                                dashboard
                            </li>
                        </ul>
                        <p>
                            Please include the email address associated with
                            your Oakmate account. We won't ask for justification
                            - simply request a refund and we'll process it.
                        </p>
                    </li>
                    <li>
                        <h2 className="policy-section-title">
                            Refund Processing
                        </h2>
                        <p>
                            We process refunds manually through Stripe within 48
                            hours of request. While Stripe submits refunds
                            immediately, banks typically take 5-10 business days
                            to reflect the amount:
                        </p>
                        <p>
                            <a
                                href="https://support.stripe.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Stripe refund processing details
                            </a>
                        </p>
                        <p>
                            You'll receive email confirmation from both Oakmate
                            and Stripe. The full subscription amount will be
                            refunded with no fees.
                        </p>
                    </li>
                    <li>
                        <h2 className="policy-section-title">
                            Subscription Access After Refund
                        </h2>
                        <p>When your refund is processed:</p>
                        <ul>
                            <li>
                                Your Pro subscription will be{" "}
                                <strong>immediately canceled</strong>
                            </li>
                            <li>Access to Pro features will be disabled</li>
                            <li>Your account will revert to the Free tier</li>
                        </ul>
                        <p>
                            You may continue using Oakmate's free features after
                            refund processing.
                        </p>
                    </li>
                    <li>
                        <h2 className="policy-section-title">
                            Non-Refundable Cases
                        </h2>
                        <p>The following are not eligible for refunds:</p>
                        <ul>
                            <li>
                                Subscription renewals after the initial 7-day
                                period
                            </li>
                            <li>Partial subscription periods</li>
                            <li>Accounts terminated for policy violations</li>
                            <li>Refund requests submitted after 7 days</li>
                        </ul>
                    </li>
                    <li>
                        <h2 className="policy-section-title">
                            Repeat Refunds Policy
                        </h2>
                        <p>
                            You may request a refund only for your{" "}
                            <strong>first</strong> subscription payment.
                            Subsequent subscriptions or resubscriptions are not
                            eligible for refunds under this policy.
                        </p>
                    </li>
                </ol>
            </section>
            <footer className="FooterSection-Container">
                <Footer />
            </footer>
        </>
    );
}
